import { useSearchParams } from 'react-router';

import type {
  DialogAdditionalParamKey,
  DialogKey,
} from 'components/navigation/WithDialogs';

export const useDialogParam = (
  dialogKey: DialogKey | DialogAdditionalParamKey
) => {
  const [searchParams] = useSearchParams();
  return searchParams.get(dialogKey);
};
